import React, { useEffect, useState } from "react";
import {
  getFirestore,
  doc,
  onSnapshot,
  updateDoc,
  deleteField,
} from "firebase/firestore";

const DeleteHistory = ({ selectedPatient, onClose }) => {
  const [background, setBackground] = useState({});
  const [selectedKey, setSelectedKey] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [confirmDelete, setConfirmDelete] = useState(false);

  useEffect(() => {
    if (!selectedPatient) return;

    const db = getFirestore();
    const patientRef = doc(db, "registeredPatients", selectedPatient.id);

    const unsubscribe = onSnapshot(
      patientRef,
      (doc) => {
        if (doc.exists()) {
          const data = doc.data();
          setBackground(data.background || {});
        } else {
          setBackground({});
        }
      },
      () => {
        setError("Ocurrió un error al cargar los antecedentes.");
      }
    );

    return () => unsubscribe();
  }, [selectedPatient]);

  const handleDelete = async () => {
    if (!selectedKey) {
      setError("Por favor, elige un antecedente para eliminar.");
      return;
    }

    try {
      const db = getFirestore();
      const patientRef = doc(db, "registeredPatients", selectedPatient.id);

      const updatedBackground = { ...background };
      delete updatedBackground[selectedKey];

      if (Object.keys(updatedBackground).length === 0) {
        await updateDoc(patientRef, { background: deleteField() });
      } else {
        await updateDoc(patientRef, { background: updatedBackground });
      }

      setSuccess("El antecedente se eliminó correctamente.");
      setError("");
      setSelectedKey("");
      setConfirmDelete(false);
    } catch (error) {
      setError("Ocurrió un error al eliminar el antecedente.");
    }
  };

  return (
    <div className="deleteHistory">
      <h2>Eliminar Antecedente</h2>
      {error && <p style={{ color: "red" }}>{error}</p>}
      {success && <p style={{ color: "green" }}>{success}</p>}

      {!confirmDelete ? (
        <>
          <select
            value={selectedKey}
            onChange={(e) => setSelectedKey(e.target.value)}
            className="generalFormInput"
            style={{
              width: "100%",
              marginBottom: "10px",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            <option value="">-- Selecciona --</option>
            {background &&
              Object.keys(background).map((key, index) => (
                <option
                  key={index}
                  value={key}
                  title={`${key} - ${background[key]}`}
                >
                  {`${key} - ${background[key]}`.length > 50
                    ? `${key.substring(0, 25)}... - ${background[key].substring(
                        0,
                        25
                      )}...`
                    : `${key} - ${background[key]}`}
                </option>
              ))}
          </select>
          <button
            onClick={() => setConfirmDelete(true)}
            disabled={!selectedKey}
          >
            Eliminar
          </button>
        </>
      ) : (
        <div className="confirmationBox">
          <p>¿Confirmas que deseas eliminar "{selectedKey}"?</p>
          <button onClick={handleDelete} className="confirmButton">
            Sí
          </button>
          <button
            onClick={() => setConfirmDelete(false)}
            className="cancelButton"
          >
            No
          </button>
        </div>
      )}
    </div>
  );
};

export default DeleteHistory;
